import { useMutation, useQuery } from "@tanstack/react-query";
import * as api from "./request";


const BASE_URL = '/api/v1';

export function useGetUsers(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['users', payload],
        async () => await api.get(`${BASE_URL}/users`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      records: items, 
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
}
export function useGetUserRoles(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['userRoles', payload],
        async () => await api.get(`${BASE_URL}/roles`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      records: items, 
      total: meta.total_count,
      isFetching, 
      refetch 
    };
}

export function useCreateUser(onSuccess?: any, onError?: any) {
    const { mutate: createUser, error, isLoading: creating } = useMutation(
        ['createUser'],
        async (payload) => await api.post(`${BASE_URL}/users`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { createUser, error, creating };
}

export function useUpdateUser(onSuccess?: any, onError?: any) {
    const { mutate: updateUser, error, isLoading: updating } = useMutation(
        ['updateUser'],
        async (payload: any) => await api.put(`${BASE_URL}/users/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { updateUser, error, updating };
}

export function useDeleteUser(onSuccess?: any, onError?: any) {
    const { mutate: deleteUser, error, isLoading: deleting } = useMutation(
        ['deleteUser'],
        async (id: string) => await api.del(`${BASE_URL}/users/${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteUser, error, deleting };
}

export function useGetCompanyUsers(company_id: any) {
    const { data, isFetching, refetch } = useQuery(
        ['companyUsers', company_id],
        async () => await api.get(`${BASE_URL}/users`, { 
          filters: {
            'companies_id_in': [company_id]
          }
        }),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled: Boolean(company_id)
        }
    );
    return { companyUsers: (data || {}).data || [], isFetching, refetch };
}
export function useCreateRole(onSuccess?: any, onError?: any) {
    const { mutate: createRole, error, isLoading: creating } = useMutation(
        ['createRole'],
        async (payload) => await api.post(`${BASE_URL}/roles`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { createRole, error, creating };
}

export function useUpdateRole(onSuccess?: any, onError?: any) {
    const { mutate: updateRole, error, isLoading: updating } = useMutation(
        ['updateRole'],
        async (payload: any) => await api.put(`${BASE_URL}/roles/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response: any) => {
                if(response.status === 200) {
                    const data = (response || {}).data || {};
                    onSuccess(data);
                } else {
                    const data = (response.response || {}).data || {};
                    onSuccess(data);
                }
            }
        }
    );
    return { updateRole, error, updating };
}

export function useDeleteRole(onSuccess?: any, onError?: any) {
    const { mutate: deleteRole, error, isLoading: deleting } = useMutation(
        ['deleteRole'],
        async (id: string) => await api.del(`${BASE_URL}/roles/${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteRole, error, deleting };
}
